import React, { useMemo } from 'react'
import { useTranslation } from 'react-i18next';
import { useTkalDataContext } from '../../../../context/tkalData';

interface InputProps extends React.DetailedHTMLProps<React.HTMLAttributes<HTMLInputElement>, HTMLInputElement> {
}

type MeasurementFieldProps = {
    propertyName: string,
    unit?: string,
    placeholderKey?: string,
    inputProps?: InputProps,
    gap?: string,
    showValue?: boolean,
}

const MeasurementFieldControlPanel = ({
    propertyName,
    unit = '',
    placeholderKey = 'Value',
    inputProps = { className: 'ahutest-form__input --value' },
    gap = '25px',
    showValue = true,

}: MeasurementFieldProps) => {
    const { controlPanelTest, setControlPanelTest } = useTkalDataContext();
    const { t } = useTranslation();

    const IsDisabled = (measurementKey: string) => {
        return useMemo(() => {
            if (controlPanelTest.measurements[measurementKey]?.statusNew !== "disabled") {
                return true
            } else {
                return false;
            }
        }, [controlPanelTest, measurementKey])
    }

    const handleChangeMeasurementsValue = (event: any, propertyName: string) => {
        setControlPanelTest({
            ...controlPanelTest,
            "measurements": { ...controlPanelTest.measurements, [event.target.name]: { ...controlPanelTest.measurements[event.target.name], [propertyName]: event.target.value } }
        })
    }

    const handleChangeMeasurementsValueUnit = (event: any, propertyName: string, unit: string) => {
        setControlPanelTest({
            ...controlPanelTest,
            "measurements": { ...controlPanelTest.measurements, [event.target.name]: { ...controlPanelTest.measurements[event.target.name], [propertyName]: event.target.value, unit: unit } }
        })
    }

    return (
        <>
            {IsDisabled(propertyName) &&
                <div className="flexboxAlignedRow" style={{ gap: gap }}>
                    {showValue &&
                        <>
                            <input {...inputProps} name={propertyName} onChange={e => handleChangeMeasurementsValueUnit(e, "value", unit)} value={controlPanelTest.measurements[propertyName]?.value ?? ""} placeholder={t(placeholderKey)} />
                            {unit}</>}
                    <input className="ahutest-form__input" name={propertyName} onChange={e => handleChangeMeasurementsValue(e, "description")} value={controlPanelTest.measurements[propertyName]?.description ?? ""} placeholder={t("Notes")} />
                </div>
            }
        </>
    );
}

export default MeasurementFieldControlPanel